import {take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {UserAuthService} from '../../@core/user-auth.service';
import {Observable} from 'rxjs';

@Injectable()
export class PermissionGuard {
    constructor(private authService: UserAuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return new Promise((resolve, reject) => {
            this.authService.user.pipe(take(1)).subscribe(user => {
                const hasPermission = !!user?.permissions &&
                    route.data.permissions.only.some(p => user.permissions.includes(p)) &&
                    (!route.data.permissions.except || route.data.permissions.except.every(p => !user.permissions.includes(p)));
                resolve(hasPermission);
                if (!hasPermission) {
                    if (!user) {
                        this.router.navigate(['/login']);
                    } else if (!hasPermission && route.data.permissions.redirectTo) {
                        this.router.navigate([route.data.permissions.redirectTo], {skipLocationChange: true});
                    }
                }
            });
        });
    }
}
